import { z } from 'zod';
export const RemoveRecordedUserRequestPathSchema = z.object({
    userId: z.string(),
});
export const RemoveRecordedUserRequestSchema = RemoveRecordedUserRequestPathSchema;
export const RemoveRecordedUserResponseSchema = z.void();
export const RemoveRecordedUserApiSchema = {
    params: RemoveRecordedUserRequestPathSchema,
};
